import type { IconPickerCategory } from "@/src/design_system/form_elements/icon_picker/constants/categories";

export const getIconPickerCategoryLabel = (category: IconPickerCategory): string => {
  const localizedLabels = window.I18n.designSystem.iconPicker.categories;

  return localizedLabels[category.labelKey];
};
